import { cn } from "@ui/utils";

type Props = {
  // Final price, degressive prices and promo codes already deducted.
  totalPrice: number;
  totalDiscount: number;
};

function TotalCart({ totalPrice, totalDiscount }: Props) {
  const hasDiscount = totalDiscount > 0;
  const priceBeforeDiscount = totalPrice + totalDiscount;

  return (
    <div className="mt-2 flex w-full flex-col gap-1 rounded-lg border border-gray-200 bg-white px-4 py-2">
      <div className="">
        <p className="text-xl font-bold">
          <span
            className={cn(
              hasDiscount && "text-sm text-gray-500 line-through"
            )}
          >{`${priceBeforeDiscount.toFixed(2)}€`}</span>
          {hasDiscount && (
            <span>{` ${totalPrice.toFixed(2)}€`}</span>
          )}
        </p>
        <p className="text-sm font-medium text-gray-500">TOTAL</p>
      </div>
    </div>
  );
}

export default TotalCart;
